import type { StepState } from '@/contracts/onboarding-session';

/** The states a job can end in: nothing more will come from it. */
export type TerminalState = Extract<StepState, 'done' | 'partial' | 'unavailable' | 'skipped'>;

const TERMINAL: readonly StepState[] = ['done', 'partial', 'unavailable', 'skipped'];

export const isTerminalState = (state: StepState): state is TerminalState => TERMINAL.includes(state);
